import { render, staticRenderFns } from "./escalation_policies_empty_state.vue?vue&type=template&id=7237545e"
import script from "./escalation_policies_empty_state.vue?vue&type=script&lang=js"
export * from "./escalation_policies_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports